<template>
    <BaseDropdownMenu :sections="menuSections" side="left" :side-offset="4" @select="handleMenuSelect">
        <template #trigger>
            <button type="button" class="base-btn-outline-sm" :title="copiedInviteId === invite.id ? 'Copied!' : 'Copy invite link'">
                <i class="bi" :class="copiedInviteId === invite.id ? 'bi-check2' : 'bi-clipboard'" aria-hidden="true"></i>
                {{ copiedInviteId === invite.id ? "Copied" : "Copy" }}
            </button>
        </template>
    </BaseDropdownMenu>
</template>

<script setup lang="ts">
import type { CycleForSubject, InviteAnonymized } from "~vue/api/generated/reflections";
import BaseDropdownMenu, { type DropdownMenuItem, type DropdownMenuSection } from "~vue/components/BaseDropdownMenu.vue";
import { useInviteCopy } from "~vue/composables/useInviteCopy";
import { toRef } from "vue";

const props = defineProps<{
    invite: InviteAnonymized;
    cycle: CycleForSubject | null;
}>();

const { copiedInviteId, copyInviteLink, copyInviteMessage } = useInviteCopy(toRef(props, "cycle"));

const menuSections: DropdownMenuSection[] = [
    {
        id: "copy",
        items: [
            { id: "copy-link", type: "button", label: "Copy link", icon: "bi bi-link-45deg" },
            { id: "copy-message", type: "button", label: "Copy invite message", icon: "bi bi-chat-quote" },
        ],
    },
];

const handleMenuSelect = (item: DropdownMenuItem) => {
    if (item.id === "copy-link") {
        copyInviteLink(props.invite);
    } else if (item.id === "copy-message") {
        copyInviteMessage(props.invite);
    }
};
</script>
